// Third party --------------
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styled from 'styled-components/macro'

// Components ---------------
import CardSection from 'loan/components/actionCards/shared/CardSection'
import Icon from 'core/components/Icon'
import { Checkbox, Button } from 'core/components'

// Rest ---------------------
import { useTime } from 'core/time'

const LoanDocSection = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: space-between;
`
const CheckboxList = styled.div`
  padding-left: 24px;
`

const CheckboxListSection = ({
  checked,
  disabledDocuments = [],
  documents,
  loanId,
  loans,
  onChange,
  showSectionByDefault
}) => {
  const { useTime } = CheckboxListSection.dependencies
  const { formatRelative } = useTime()
  const [showLoanDocSection, setShowLoanDocSection] = useState(
    showSectionByDefault || false
  )

  const formatTime = date => {
    return formatRelative(date, {
      isCapitalized: true,
      showTime: false
    })
  }
  return (
    <>
      <CardSection label={loans[loanId]?.displayId} labelWidth='136px'>
        <LoanDocSection>
          <Button
            className={`button-toggle-loan-doc-${loanId}`}
            fontSize='24px'
            onClick={() => setShowLoanDocSection(!showLoanDocSection)}
          >
            {showLoanDocSection ? (
              <Icon name='keyboard_arrow_up' />
            ) : (
              <Icon name='keyboard_arrow_down' />
            )}
          </Button>
          {showLoanDocSection && (
            <CheckboxList className={`checkbox-list-${loanId}`}>
              {documents.map((document, index) => {
                const disabled = disabledDocuments.includes(document.id)
                const disabledReason =
                  'If you would like to dissociate, remove this from a document case-detail field.'
                return (
                  <Checkbox
                    key={document.id}
                    label={`${formatTime(document.createdAt)}, ${
                      document.description || document.fileName
                    }`}
                    value={document.id}
                    onChange={e => onChange(document.id, e.target.checked)}
                    checked={checked[document.id].checked}
                    margin={index === 0 ? '' : '16px 0 0'}
                    className={`checkbox-${document.id}`}
                    disabled={disabled}
                    disabledReason={disabledReason}
                  />
                )
              })}
            </CheckboxList>
          )}
        </LoanDocSection>
      </CardSection>
    </>
  )
}

CheckboxListSection.propTypes = {
  checked: PropTypes.object,
  disabledDocuments: PropTypes.arrayOf(PropTypes.string),
  documents: PropTypes.array,
  loanId: PropTypes.string,
  loans: PropTypes.object,
  onChange: PropTypes.func,
  showSectionByDefault: PropTypes.bool
}

CheckboxListSection.dependencies = {
  useTime
}

export default CheckboxListSection
